module.exports = __webpack_public_path__ + "static/media/IconTemplates_-64.b3d1ee27.svg";